import { useTranslation } from "../../../i18n/LanguageProvider";

function ContactForm({ formData, loading, submitStatus, onChange, onSubmit }) {
    const { t } = useTranslation();

    return (
        <form className="contacts__form card-common" onSubmit={onSubmit}>
            <h2>{t("contact.formTitle")}</h2>

            <div className="contacts__field">
                <label htmlFor="contact-name">
                    {t("contact.name")} <span aria-hidden="true">*</span>
                </label>
                <input
                    id="contact-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={onChange}
                    placeholder={t("contact.namePlaceholder")}
                    autoComplete="name"
                    required
                />
            </div>

            <div className="contacts__field">
                <label htmlFor="contact-email">{t("contact.email")}</label>
                <input
                    id="contact-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={onChange}
                    placeholder="email@exemplu.com"
                    autoComplete="email"
                />
            </div>

            <div className="contacts__field">
                <label htmlFor="contact-subject">{t("contact.subject")}</label>
                <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={onChange}
                    placeholder={t("contact.subjectPlaceholder")}
                />
            </div>

            <div className="contacts__field">
                <label htmlFor="contact-message">
                    {t("contact.message")} <span aria-hidden="true">*</span>
                </label>
                <textarea
                    id="contact-message"
                    name="message"
                    value={formData.message}
                    onChange={onChange}
                    placeholder={t("contact.messagePlaceholder")}
                    rows={6}
                    required
                />
            </div>

            <button type="submit" className="contacts__submit" disabled={loading}>
                {loading ? t("contact.sending") : t("contact.submit")}
            </button>

            {submitStatus && (
                <div className={`contacts__status contacts__status--${submitStatus.type}`}>
                    {submitStatus.message}
                </div>
            )}
        </form>
    );
}

export default ContactForm;
